// extracted by extract-css-chunks-webpack-plugin
module.exports = {"BLSpinner":"spinner__BLSpinner__2YnrQ","BLSpinnerSm":"spinner__BLSpinnerSm__2__x4","BLSpinnerLg":"spinner__BLSpinnerLg__2YEZZ"};